module.exports = __webpack_public_path__ + "KaTeX_Size3-Regular.ac0dd6b6.woff";